<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
        
        <div class="d-sm-flex align-items-center">
        </div>
        <div class="d-sm-flex align-items-center mt-10 mt-lg-0">
          
          <button @click="openAddMappingBox" class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
          Add Mapping
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive" style="overflow: visible;">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Field
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Qwilr Field
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="mapping in filteredQwilrSubstitutionMappings" :key="mapping.id">
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ mapping.field }}
                </th>
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ mapping.qwilrField }}
                </th>
                <td class="shadow-none lh-1 fw-medium text-end pe-0">
                  <div class="dropdown">
                    <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="flaticon-dots"></i>
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" @click.prevent="deleteMapping(mapping.id)"
                          ><i
                            class="flaticon-delete lh-1 me-8 position-relative top-1"
                          ></i>
                          Delete</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" @click.prevent="openUpdateSubstitutionMappingBox(mapping)"
                          ><i
                            class="flaticon-delete lh-1 me-8 position-relative top-1"
                          ></i>
                          Update</a
                        >
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
          <p class="mb-0 text-paragraph">
            Showing <span class="fw-bold">{{ filteredQwilrSubstitutionMappings.length }}</span> out of
            <span class="fw-bold">{{ totalQwilrSubstitutionMappings }}</span> results
          </p>
        </div>
      </div>

      <Lightbox v-if="showAddMappingBox" @close="closeAddMappingBox">
        <AddQwilrSubstitutionMapping :qwilrDefinitionId="this.qwilrDefinitionId" :qwilrDefinitionElementId="this.qwilrDefinitionElementId" @mappingAdded="handleMappingAdded" @close="closeAddMappingBox"/>
      </Lightbox>
      <Lightbox v-if="showUpdateSubstitutionMappingBox" @close="closeUpdateSubstitutionMappingBox">
        <UpdateQwilrSubstitutionMapping :mapping="this.selectedMapping" @mappingUpdated="handleMappingUpdated" @close="closeUpdateSubstitutionMappingBox"/>
      </Lightbox>
    </div>

    <div class="row">
      <div class="col-md-6">
        <button @click="goToMainMenu" class="default-btn transition border-0 fw-medium text-white 
            pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 
            fs-md-15 fs-lg-16 m-5 bg-primary" type="button"> Back </button>
      </div>
    </div>
  </template>
  
  <script>
  import { GetQwilrSubstitutionMappings,DeleteQwilrSubstitutionMapping } from '@/core/services/entities/qwilr.service'
  import breadcrumbMixin from '@/mixins/BreadcrumbMixin'
  import Lightbox from '@/components/Common/LightboxWrapper.vue';
  import AddQwilrSubstitutionMapping from "./AddQwilrSubstitutionMapping.vue";
  import UpdateQwilrSubstitutionMapping from "./UpdateQwilrSubstitutionMapping.vue";
  import { useToast } from 'vue-toastification'
  import Swal from 'sweetalert2';

  export default {
    name: "QwilrSubstituionMapping",
    components: {
        Lightbox,
        AddQwilrSubstitutionMapping,
        UpdateQwilrSubstitutionMapping
    },
    data() {
      return {
        searchQuery: "", 
        filteredQwilrSubstitutionMappings: [], 
        pageSize: 10, 
        pageIndex: 1, 
        totalQwilrSubstitutionMappings: 0, 
        totalPages: 1, 
        showAddMappingBox: false,
        selectedMapping:null,
        showUpdateSubstitutionMappingBox: false,
        qwilrDefinitionElementId:null,
        qwilrDefinitionId:null
      };
    },
    mixins: [breadcrumbMixin],
    methods: {
      async fetchQwilrSubstituionMappingsByFilter(filter = "") {
        const elementType=1;
        let data = await GetQwilrSubstitutionMappings(this.qwilrDefinitionElementId, filter, this.pageSize,this.pageIndex);
        console.log(data)
        if(data)
        {
          this.filteredQwilrSubstitutionMappings = data.qwilrSubstitutionMappings;
          this.totalQwilrSubstitutionMappings = data.qwilrSubstitutionMappings.length;
        }

      },
      handleSearch(event) {
        event.preventDefault();
        const filter = this.searchQuery.trim();
        this.pageIndex = 1; 
        this.fetchQwilrSubstituionMappingsByFilter(filter);
      },
      changePage(page) {
        if (page > 0 && page <= this.totalPages) {
          this.pageIndex = page;
          this.fetchQwilrSubstituionMappingsByFilter(this.searchQuery);
        }
      },
      openAddMappingBox(){
        this.showAddMappingBox=true;
      },
      closeAddMappingBox(){
        this.showAddMappingBox=false;
      },
      handleMappingAdded(){
        this.fetchQwilrSubstituionMappingsByFilter("");
      },
      closeUpdateSubstitutionMappingBox(){
        this.showUpdateSubstitutionMappingBox=false;
      },
      handleMappingUpdated(){
        this.fetchQwilrSubstituionMappingsByFilter("");
      },
      openUpdateSubstitutionMappingBox(mapping){
        this.selectedMapping=mapping;
        this.showUpdateSubstitutionMappingBox=true;
      },
      async goToMainMenu() {
            this.$router.push({ name: 'qwilrDefinitionPage', params: { id: this.qwilrDefinitionId } });
      },
      async deleteMapping(mappingId) {
        const toast = useToast();

        // Show confirmation dialog using SweetAlert2
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {  
          if (result.isConfirmed) {
            try {
              const payload = { id: mappingId };
              let response = await DeleteQwilrSubstitutionMapping(payload);  
              if (response.status === 200) {
                toast.success('Mapping deleted successfully!', {
                  timeout: 2000,
                });
                this.fetchQwilrSubstituionMappingsByFilter("");
              }
            } catch (ex) {
              const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
              console.log(errorMessage);
              toast.error(`Failed to delete mapping: ${errorMessage}`, {
                timeout: 2000,
              });
            }
          } else {
            toast.info('Mapping deletion canceled.', { timeout: 2000 });
          }
        });

      }
    },
    created() {
      this.qwilrDefinitionElementId = this.$route.params.id;
      this.qwilrDefinitionId = this.$route.params.qwilrDefinitionId;
      this.fetchQwilrSubstituionMappingsByFilter("");
    }
  };
  </script>


  